import { render, staticRenderFns } from "./sale-detail.vue?vue&type=template&id=1ff3546c"
import script from "./sale-detail.vue?vue&type=script&lang=js"
export * from "./sale-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports